import PropTypes from 'prop-types';
import React from 'react';
import VM from 'scratch-vm';

import Box from '../box/box.jsx';
import {STAGE_DISPLAY_SIZES} from '../../lib/layout-constants.js';
import StageHeader from '../../containers/stage-header.jsx';
import Stage from '../../containers/stage.jsx';
import Loader from '../loader/loader.jsx';
import Controls from '../../containers/controls.jsx';
import KeyBoard from '../../containers/stage-key-board.jsx';
import WorkDescription from '../../containers/work-description.jsx';

import keyGameBgc from './background.jpg';

import styles from './stage-wrapper.css';
import classNames from "classnames";
// import mide from "../key-gamepad/image/mide.png";
import mide from "../key-gamepad/image/mide-logo.png";
import {connect} from "react-redux";

const StageWrapperComponent = function (props) {
    const isMobile = location.search.indexOf('isMobile') !== -1;
    const clientWidth = window.innerWidth;
    const clientHeight = window.innerHeight;
    const {
        isFullScreen,
        isRtl,
        isRendererSupported,
        loading,
        stageSize,
        vm,
        keyboardType,
        workDescriptionState,
        workInfo,
        workDescription,
        workIsShare
    } = props;

    let header = null;
    let operation = null;
    if (isMobile) {
        header = null;
        operation = (
            <Controls vm={vm} workIsShare={props.workIsShare} workInfo={workInfo} description={workDescription} isMobile/>
        )
    } else {
        header = (
            <Box className={styles.stageMenuWrapper}>
                <StageHeader
                    stageSize={stageSize}
                    vm={vm}
                />
            </Box>
        );
        operation = null;
    }

    function studentNameSlice(workData, workIsShareData) {
        // let name = this.props.workInfo.userName;
        // if (this.props.workIsShare && this.props.workInfo.userName && this.props.workInfo.userName.length > 1) {
        //     if (this.props.workInfo.userName.length <= 3) {
        //         name = this.props.workInfo.userName.slice(1);
        //     } else {
        //         name = this.props.workInfo.userName.slice(2);
        //     }
        // }
        // let name = workData.userName;
        // if (workIsShareData && workData.userName && workData.userName.length > 1) {
        //     if (workData.userName.length <= 3) {
        //         name = workData.userName.slice(1);
        //     } else {
        //         name = workData.userName.slice(2);
        //     }
        // }
        return workData.userName;
    }
    return (
        <div
            className={classNames(
                styles.stageWrapper,
                isMobile ? styles.stageWrapperIsMobile : ''
            )}
            dir={isRtl ? 'rtl' : 'ltr'}
        >
            {!isFullScreen &&
                <img
                    className={isMobile ? styles.mobileBgc : styles.webBgc}
                    style={{top: `${isMobile ? 3 * clientWidth / 4 : 408}px`, height: `${isMobile ? clientHeight - 3 * clientWidth / 4 : 499}px`}}
                    src={keyGameBgc}
                    alt=""
                />
            }
            {header}
            <div className={styles.stageCanvasWrapper}>
                {
                    isRendererSupported ?
                        <Stage
                            stageSize={stageSize}
                            vm={vm}
                            isMobile={isMobile}
                        /> :
                        null
                }
            </div>
            {operation}
            {!isFullScreen &&
                <KeyBoard />
            }
            {!loading && keyboardType !== 0 && !isFullScreen &&
                <div>
                    <div className={styles.mide} style={{bottom: !isMobile && keyboardType === -1 ? '-6.65rem' : '0.2rem'}}>
                        <img src={mide} alt=""/>
                    </div>
                    <div className={styles.userName} style={{bottom: !isMobile && keyboardType === -1 ? '-6.65rem' : '0.2rem'}}>
                        {studentNameSlice(props.workInfo, props.workIsShare)}
                        <span>{workDescriptionState}</span>
                    </div>
                </div>
            }
            {loading && isMobile ? (
                <Loader isFullScreen={isFullScreen} />
            ) : null}
            {/* 作品简介*/}
            {
                isMobile && workDescriptionState ? (<WorkDescription/>):null
            }

        </div>
    );
};

StageWrapperComponent.propTypes = {
    isFullScreen: PropTypes.bool,
    isRendererSupported: PropTypes.bool.isRequired,
    isRtl: PropTypes.bool.isRequired,
    loading: PropTypes.bool,
    stageSize: PropTypes.oneOf(Object.keys(STAGE_DISPLAY_SIZES)).isRequired,
    vm: PropTypes.instanceOf(VM).isRequired,
    keyboardType: PropTypes.number,
    workInfo: PropTypes.object,
    workIsShare: PropTypes.number,
    workDescriptionState: PropTypes.bool, // 简介状态
    workDescription: PropTypes.object, // 简介数据
};

const mapStateToProps = state => ({
    keyboardType: state.scratchGui.projectState.keyboardType,
    workInfo: state.scratchGui.projectState.workInfo,
    workIsShare: state.scratchGui.projectState.workIsShare,
    workDescription: state.scratchGui.projectState.workDescription, // 作品简介
    workDescriptionState: state.scratchGui.vmStatus.workDescriptionState,
});

const mapDispatchToProps = dispatch => ({});

export default connect(mapStateToProps, mapDispatchToProps)(StageWrapperComponent);
